import styled from 'styled-components';

const Overlay = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;

    background: rgba(0,0,0,0.3);
    text-align: center;  
`;

export default Overlay;
